import { DBFindOne, DBInsert, DBRemove, DBUpdateOne } from '@weblite/persist'
import { UploadingFile } from '$logic/persist-uploads/types'

const COLLECTION = 'uploadingFiles'

export const uploadingFilesStorage = {
  delete(id: string) {
    return DBRemove(COLLECTION, id)
  },

  get(id: string): Promise<UploadingFile> {
    return DBFindOne(COLLECTION, id)
  },

  insert(persistUpload: UploadingFile) {
    return DBInsert(COLLECTION, persistUpload)
  },

  update(id: string, persistUpload: Partial<UploadingFile>) {
    return DBUpdateOne(COLLECTION, id, {
      $set: persistUpload,
    })
  },
}
